import { useTheme } from "@material-ui/core";
import React, { ImgHTMLAttributes, ReactElement } from "react";

interface IProps extends ImgHTMLAttributes<SVGSVGElement> {
  //   className?: string | string[];
  //   style?: React.CSSProperties;
  name: string;
}

export enum SVG_ICONS {
  WARNING = "WARNING",
  XLSX = "XLSX",
  UPLOAD_WHITE = "UPLOAD_WHITE",
  UPLOAD_OUTLINED = "UPLOAD_OUTLINED",
  UPLOAD_GREEN = "UPLOAD_GREEN",
  UPLOAD_FILE = "UPLOAD_FILE",
  UPLOAD_ACTIVE = "UPLOAD_ACTIVE",
  ACCOUNT = "ACCOUNT",
  ARROW_CIRCLE_DOWN = "ARROW_CIRCLE_DOWN",
  ARROW_CIRCLE_UP = "ARROW_CIRCLE_UP",
  SCRIVE = "SCRIVE",
  ARROW_RIGHT = "ARROW_RIGHT",
  DELETE_CHIP = "DELETE_CHIP",
  ADD = "ADD",
  ARTICLES = "ARTICLES",
  INVOICES = "INVOICES",
  OVERVIEW = "OVERVIEW",
  CHECK = "CHECK",
  DOT = "DOT",
  RADIO_CHECKED = "RADIO_CHECKED",
  RADIO_UNCHECKED = "RADIO_UNCHECKED",
  RADIO_INACTIVE = "RADIO_INACTIVE",
  ADD_OUTLINE = "ADD_OUTLINE",
  MORE = "MORE",
  MORE_ACTIVE = "MORE_ACTIVE",
  IGNORE = "IGNORE",
  RESOLVE = "RESOLVE",
  CLOSE = "CLOSE",
  DOWNLOAD_OUTLINE = "DOWNLOAD_OUTLINE",
  DOWNLOAD = "DOWNLOAD",
  SETTING = "SETTING",
  EDIT = "EDIT",
  EDIT_OUTLINE = "EDIT_OUTLINE",
  USER = "USER",
  GLOBAL = "GLOBAL",
  DEVIATION = "DEVIATION",
  LINK = "LINK",
  DELETE = "DELETE",
  DELETE_GREY = "DELETE_GREY",
  DELETE_OUTLINE = "DELETE_OUTLINE",
  DELETE_DIALOG = "DELETE_DIALOG",
  SUCCESS = "SUCCESS",
  NOT_SUPPORT = "NOT_SUPPORT",
  DELETE_FOREVER = "SELETE_FOREVER",
}

const SVG = (props: IProps) => {
  const theme = useTheme();
  const icons: { [index: string]: ReactElement } = {
    [SVG_ICONS.DELETE_FOREVER]: (
      <svg
        width="14"
        height="18"
        viewBox="0 0 14 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M1 16C1 17.1 1.9 18 3 18H11C12.1 18 13 17.1 13 16V4H1V16ZM3.46 8.88L4.87 7.47L7 9.59L9.12 7.47L10.53 8.88L8.41 11L10.53 13.12L9.12 14.53L7 12.41L4.88 14.53L3.47 13.12L5.59 11L3.46 8.88ZM10.5 1L9.5 0H4.5L3.5 1H0V3H14V1H10.5Z"
          fill="#6B7280"
        />
      </svg>
    ),
    [SVG_ICONS.NOT_SUPPORT]: (
      <svg
        width="16"
        height="14"
        viewBox="0 0 16 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M4.03333 5.29167C3.81667 4.89167 3.70833 4.43333 3.70833 3.9C3.70833 3.39167 3.81667 2.93333 4.04167 2.50833C4.25833 2.09167 4.56667 1.73333 4.96667 1.43333C5.36667 1.14167 5.84167 0.908333 6.38333 0.741667C6.93333 0.583333 7.54167 0.5 8.2 0.5C8.875 0.5 9.48333 0.591667 10.0417 0.783333C10.5917 0.966667 11.0667 1.23333 11.45 1.56667C11.8417 1.9 12.1417 2.3 12.35 2.75833C12.5583 3.21667 12.6667 3.71667 12.6667 4.26667H10.1583C10.1583 4.00833 10.1167 3.775 10.0333 3.55833C9.95833 3.33333 9.83333 3.15 9.66667 2.99167C9.5 2.83333 9.29167 2.71667 9.04167 2.625C8.79167 2.54167 8.49167 2.49167 8.15833 2.49167C7.83333 2.49167 7.54167 2.525 7.3 2.6C7.05833 2.675 6.85833 2.775 6.7 2.9C6.54167 3.03333 6.41667 3.18333 6.33333 3.35833C6.25 3.53333 6.20833 3.71667 6.20833 3.90833C6.20833 4.30833 6.41667 4.64167 6.825 4.91667C7.14167 5.125 7.46667 5.31667 8 5.5H4.15833C4.11667 5.43333 4.06667 5.35833 4.03333 5.29167V5.29167ZM15.5 8V6.33333H0.5V8H8.51667C8.66667 8.05833 8.85 8.11667 8.975 8.16667C9.28333 8.30833 9.525 8.45 9.7 8.59167C9.875 8.73333 9.99167 8.89167 10.0583 9.06667C10.1167 9.23333 10.15 9.425 10.15 9.64167C10.15 9.83333 10.1083 10.0167 10.0333 10.1917C9.95833 10.3583 9.84167 10.5083 9.68333 10.6333C9.525 10.7583 9.33333 10.85 9.09167 10.925C8.85 10.9917 8.56667 11.0333 8.25 11.0333C7.89167 11.0333 7.55833 11 7.26667 10.925C6.975 10.85 6.71667 10.7333 6.50833 10.575C6.3 10.4167 6.13333 10.2083 6.01667 9.95C5.9 9.69167 5.80833 9.31667 5.80833 8.94167H3.33333C3.33333 9.4 3.4 9.88333 3.53333 10.2583C3.66667 10.6333 3.84167 10.9667 4.075 11.2667C4.30833 11.5583 4.575 11.8167 4.89167 12.0333C5.2 12.25 5.54167 12.4333 5.90833 12.575C6.275 12.7167 6.65833 12.825 7.05833 12.9C7.45833 12.9667 7.85833 13.0083 8.25833 13.0083C8.925 13.0083 9.53333 12.9333 10.075 12.775C10.6167 12.6167 11.0833 12.4 11.4667 12.1167C11.85 11.8333 12.15 11.475 12.3583 11.0583C12.5667 10.6417 12.675 10.1667 12.675 9.63333C12.675 9.13333 12.5917 8.68333 12.4167 8.29167C12.375 8.2 12.325 8.1 12.275 8.01667H15.5V8Z"
          fill="#6B7280"
        />
      </svg>
    ),
    [SVG_ICONS.SUCCESS]: (
      <svg
        width="18"
        height="20"
        viewBox="0 0 18 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.64092 0.0362694C8.8067 -0.012112 8.98286 -0.0120893 9.14862 0.0363347L17.1299 2.36783C17.5162 2.48066 17.7817 2.83481 17.7817 3.23722V8.01856C17.7817 13.434 14.316 18.2417 9.17831 19.9536C8.99248 20.0155 8.79159 20.0155 8.60576 19.9536C3.46671 18.2418 0 13.433 0 8.01634V3.23722C0 2.83473 0.265608 2.48052 0.651979 2.36777L8.64092 0.0362694ZM1.81144 3.91639V8.01634C1.81144 12.5519 4.65079 16.5895 8.89195 18.1352C13.1319 16.5895 15.9702 12.5529 15.9702 8.01856V3.91621L8.89454 1.84926L1.81144 3.91639ZM13.9675 6.47593C14.3212 6.82964 14.3212 7.40311 13.9675 7.75681L8.64405 13.0802C8.47419 13.2501 8.24382 13.3455 8.00361 13.3455C7.7634 13.3455 7.53302 13.2501 7.36317 13.0802L4.25784 9.9749C3.90414 9.6212 3.90414 9.04773 4.25784 8.69402C4.61155 8.34031 5.18502 8.34031 5.53872 8.69402L8.00361 11.1589L12.6866 6.47593C13.0403 6.12223 13.6138 6.12223 13.9675 6.47593Z"
          fill="#29A777"
        />
      </svg>
    ),
    [SVG_ICONS.DELETE_DIALOG]: (
      <svg
        width="74"
        height="74"
        viewBox="0 0 74 74"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <circle cx="37" cy="37" r="37" fill="#F23A4B" />
        <path
          d="M31.7723 26.3791C31.7723 25.8684 31.7692 25.4125 31.7723 24.9581C31.788 23.3177 33.0194 22.0439 34.6614 22.0204C36.3848 21.9954 38.1082 21.9922 39.8301 22.0173C41.4924 22.0408 42.7223 23.313 42.7427 24.9816C42.7489 25.4344 42.7442 25.8887 42.7442 26.3807C42.9385 26.3807 43.092 26.3807 43.2456 26.3807C45.5691 26.387 47.8926 26.3917 50.216 26.4073C50.4573 26.4089 50.719 26.4434 50.9336 26.5436C51.3551 26.7379 51.5854 27.2565 51.4992 27.6921C51.4036 28.1793 51.037 28.5428 50.5341 28.5773C50.0406 28.6118 49.5423 28.5929 49.0472 28.5977C48.8937 28.5992 48.7386 28.5977 48.5349 28.5977C48.4864 29.3325 48.4378 30.0297 48.3939 30.7284C48.0414 36.3562 47.692 41.9824 47.3395 47.6101C47.175 50.236 45.3059 51.9955 42.6737 51.997C39.0702 52.0002 35.4682 52.0017 31.8647 51.997C29.253 51.9939 27.387 50.1859 27.2256 47.5757C26.9342 42.8739 26.613 38.172 26.3059 33.4718C26.2103 32.0132 26.1007 30.5545 26.0333 29.0959C26.0145 28.6838 25.875 28.5616 25.4787 28.5914C25.0368 28.6243 24.5919 28.6086 24.1485 28.5945C23.4717 28.5741 23.0063 28.1261 23.0001 27.5088C22.9938 26.8758 23.4732 26.4089 24.1642 26.4042C26.5268 26.3901 28.8895 26.387 31.2521 26.3807C31.4072 26.3791 31.5639 26.3791 31.7723 26.3791ZM46.318 28.6603C40.2688 28.6603 34.2853 28.6603 28.2847 28.6603C28.2847 28.8703 28.2737 29.0755 28.2863 29.2808C28.3724 30.7002 28.4696 32.1197 28.5526 33.5392C28.8252 38.2159 29.0916 42.8927 29.3642 47.5694C29.441 48.8745 30.37 49.7911 31.6767 49.7958C35.3962 49.8083 39.1156 49.8067 42.8351 49.7911C44.123 49.7864 45.0552 48.8855 45.1413 47.6007C45.2855 45.4402 45.4155 43.2781 45.5503 41.116C45.7524 37.8869 45.9561 34.6563 46.1566 31.4272C46.2146 30.531 46.2616 29.6348 46.318 28.6603ZM40.5461 26.3525C40.5461 25.8809 40.5539 25.4391 40.5429 24.9988C40.532 24.5507 40.286 24.3032 39.8348 24.286C39.4697 24.2734 39.1047 24.2813 38.7396 24.2813C37.4094 24.2813 36.0777 24.2781 34.7475 24.2844C34.2853 24.286 34.0018 24.5006 33.9798 24.8923C33.9532 25.3701 33.9736 25.8511 33.9736 26.3509C36.1686 26.3525 38.3291 26.3525 40.5461 26.3525Z"
          fill="white"
        />
        <path
          d="M31.7722 39.1554C31.7722 37.2769 31.7706 35.3983 31.7722 33.5198C31.7722 32.7521 32.1952 32.2649 32.858 32.2586C33.5191 32.2492 33.9672 32.7411 33.9672 33.4979C33.9704 37.3082 33.9688 41.117 33.9657 44.9273C33.9657 45.6449 33.5019 46.1431 32.8595 46.1368C32.2203 46.1306 31.7738 45.6323 31.7722 44.9085C31.7706 42.9908 31.7722 41.0731 31.7722 39.1554Z"
          fill="white"
        />
        <path
          d="M38.3544 39.2012C38.3544 41.1063 38.3529 43.0115 38.356 44.9151C38.3576 45.3992 38.1868 45.7862 37.7497 46.0149C37.029 46.3925 36.1923 45.8802 36.1625 45.0404C36.1437 44.4795 36.1594 43.9186 36.1594 43.3577C36.1594 40.0707 36.1594 36.7821 36.1594 33.4951C36.1594 32.8966 36.4226 32.4767 36.8848 32.32C37.6369 32.0646 38.3466 32.5817 38.3497 33.4073C38.3607 35.3391 38.3544 37.2694 38.3544 39.2012Z"
          fill="white"
        />
        <path
          d="M40.5447 39.2022C40.5447 37.297 40.5478 35.3919 40.5415 33.4867C40.54 33.0198 40.6904 32.6359 41.104 32.3994C41.8498 31.9748 42.7256 32.4949 42.735 33.3786C42.7506 34.657 42.7412 35.9355 42.7412 37.2155C42.7412 39.7866 42.7397 42.3576 42.7397 44.9271C42.7397 45.4457 42.5423 45.8468 42.0534 46.0536C41.3014 46.3732 40.5494 45.8264 40.5447 44.9553C40.5384 43.0893 40.5415 41.2233 40.5415 39.3573C40.5447 39.3072 40.5447 39.2539 40.5447 39.2022Z"
          fill="white"
        />
      </svg>
    ),
    [SVG_ICONS.DELETE_OUTLINE]: (
      <svg
        width="19"
        height="20"
        viewBox="0 0 19 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <g clipPath="url(#clip0_12332:5442)">
          <path
            d="M17.1986 5.20934C12.3895 4.72752 7.58954 4.5457 2.835 5.02752L0.980454 5.20934C0.598636 5.2457 0.262272 4.97297 0.225909 4.59115C0.189545 4.20934 0.462272 3.88206 0.835 3.8457L2.68954 3.66388C7.52591 3.17297 12.4259 3.36388 17.335 3.8457C17.7077 3.88206 17.9805 4.21843 17.9441 4.59115C17.9168 4.9457 17.6168 5.20934 17.2714 5.20934C17.2532 5.20934 17.2259 5.20934 17.1986 5.20934Z"
            fill="#212121"
          />
          <path
            d="M5.79087 4.28208C5.42724 4.21845 5.17269 3.8639 5.23633 3.50027L5.43633 2.30936C5.58178 1.43663 5.78178 0.227539 7.89996 0.227539H10.2818C12.4091 0.227539 12.6091 1.48208 12.7454 2.31845L12.9454 3.50027C13.0091 3.87299 12.7545 4.22754 12.3909 4.28208C12.0181 4.34572 11.6636 4.09118 11.6091 3.72754L11.4091 2.54572C11.2818 1.75481 11.2545 1.60027 10.2909 1.60027H7.90906C6.94542 1.60027 6.92724 1.72754 6.79087 2.53663L6.58178 3.71845C6.52724 4.05481 6.23633 4.29118 5.90906 4.29118C5.87269 4.29118 5.83633 4.29118 5.79087 4.28208Z"
            fill="#212121"
          />
          <path
            d="M6.17237 19.7731C2.99964 19.7731 2.87237 18.0186 2.77237 16.6004L2.18146 7.44588C2.15419 7.07315 2.4451 6.74588 2.81782 6.71861C3.19964 6.70042 3.51782 6.98224 3.5451 7.35497L4.13601 16.5095C4.23601 17.8913 4.27237 18.4095 6.17237 18.4095H12.0087C13.9178 18.4095 13.9542 17.8913 14.0451 16.5095L14.636 7.35497C14.6633 6.98224 14.9906 6.70042 15.3633 6.71861C15.736 6.74588 16.0269 7.06406 15.9996 7.44588L15.4087 16.6004C15.3087 18.0186 15.1815 19.7731 12.0087 19.7731H6.17237Z"
            fill="#212121"
          />
          <path
            d="M7.57244 14.7728C7.19972 14.7728 6.89062 14.4637 6.89062 14.091C6.89062 13.7183 7.19972 13.4092 7.57244 13.4092H10.5997C10.9724 13.4092 11.2815 13.7183 11.2815 14.091C11.2815 14.4637 10.9724 14.7728 10.5997 14.7728H7.57244Z"
            fill="#212121"
          />
          <path
            d="M6.81854 11.1361C6.44581 11.1361 6.13672 10.827 6.13672 10.4543C6.13672 10.0816 6.44581 9.77246 6.81854 9.77246H11.364C11.7367 9.77246 12.0458 10.0816 12.0458 10.4543C12.0458 10.827 11.7367 11.1361 11.364 11.1361H6.81854Z"
            fill="#212121"
          />
        </g>
        <defs>
          <clipPath id="clip0_12332:5442">
            <rect width="18.1818" height="20" fill="white" />
          </clipPath>
        </defs>
      </svg>
    ),
    [SVG_ICONS.DELETE_GREY]: (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M7.38275 3.50331C7.38275 3.0947 7.38011 2.72996 7.38275 2.36647C7.39593 1.05417 8.43233 0.0351538 9.8142 0.0163528C11.2646 -0.00370159 12.7151 -0.00620839 14.1642 0.013846C15.5632 0.032647 16.5983 1.05041 16.6154 2.38528C16.6207 2.74751 16.6167 3.11099 16.6167 3.50456C16.7802 3.50456 16.9094 3.50456 17.0387 3.50456C18.9941 3.50957 20.9496 3.51333 22.905 3.52587C23.1081 3.52712 23.3283 3.5547 23.5089 3.63491C23.8636 3.79034 24.0574 4.20521 23.9849 4.55366C23.9045 4.94346 23.5959 5.23425 23.1727 5.26183C22.7573 5.2894 22.338 5.27436 21.9213 5.27812C21.7921 5.27937 21.6616 5.27812 21.4902 5.27812C21.4493 5.86596 21.4084 6.42373 21.3715 6.98274C21.0748 11.4849 20.7808 15.9859 20.4841 20.4881C20.3456 22.5888 18.7726 23.9964 16.5574 23.9976C13.5247 24.0001 10.4933 24.0014 7.46054 23.9976C5.26248 23.9951 3.69206 22.5487 3.55625 20.4605C3.31099 16.6991 3.04068 12.9376 2.78224 9.17744C2.70181 8.01053 2.60951 6.84362 2.55281 5.6767C2.53699 5.34706 2.41963 5.24929 2.08604 5.27311C1.7142 5.29943 1.33972 5.28689 0.966566 5.27561C0.396942 5.25932 0.0053254 4.90085 5.11037e-05 4.40701C-0.00522319 3.90064 0.398261 3.52712 0.979752 3.52336C2.96816 3.51208 4.95657 3.50957 6.94498 3.50456C7.07552 3.50331 7.20738 3.50331 7.38275 3.50331ZM19.6244 5.32826C14.5334 5.32826 9.49774 5.32826 4.4476 5.32826C4.4476 5.49621 4.43837 5.66041 4.44892 5.8246C4.52144 6.96018 4.60319 8.09576 4.67308 9.23134C4.90251 12.9727 5.12667 16.7141 5.3561 20.4555C5.42071 21.4996 6.20262 22.2328 7.30231 22.2366C10.4326 22.2466 13.5629 22.2454 16.6932 22.2328C17.7771 22.2291 18.5616 21.5084 18.6341 20.4806C18.7554 18.7522 18.8649 17.0225 18.9783 15.2928C19.1484 12.7095 19.3198 10.125 19.4886 7.54176C19.5374 6.82481 19.5769 6.10787 19.6244 5.32826ZM14.7668 3.482C14.7668 3.10473 14.7734 2.75127 14.7641 2.39906C14.7549 2.04059 14.5479 1.84255 14.1681 1.82877C13.8609 1.81874 13.5537 1.82501 13.2464 1.82501C12.127 1.82501 11.0062 1.8225 9.88672 1.82751C9.49774 1.82877 9.25908 2.00048 9.24062 2.31383C9.2182 2.69612 9.23534 3.08091 9.23534 3.48075C11.0827 3.482 12.901 3.482 14.7668 3.482Z"
          fill="#898989"
        />
        <path
          d="M7.3834 13.7261C7.3834 12.2232 7.38208 10.7204 7.3834 9.21759C7.3834 8.60342 7.73941 8.21362 8.29717 8.2086C8.85361 8.20108 9.23072 8.59465 9.23072 9.20004C9.23336 12.2483 9.23204 15.2953 9.2294 18.3436C9.2294 18.9176 8.8391 19.3162 8.29849 19.3112C7.76051 19.3062 7.38472 18.9076 7.3834 18.3285C7.38208 16.7944 7.3834 15.2602 7.3834 13.7261Z"
          fill="#898989"
        />
        <path
          d="M12.9223 13.761C12.9223 15.2851 12.921 16.8093 12.9236 18.3322C12.9249 18.7195 12.7812 19.029 12.4133 19.212C11.8068 19.5141 11.1027 19.1043 11.0776 18.4324C11.0618 17.9837 11.075 17.535 11.075 17.0863C11.075 14.4567 11.075 11.8258 11.075 9.19614C11.075 8.71734 11.2965 8.38143 11.6855 8.25609C12.3184 8.05179 12.9157 8.46541 12.9183 9.12595C12.9276 10.6714 12.9223 12.2156 12.9223 13.761Z"
          fill="#898989"
        />
        <path
          d="M14.7655 13.7599C14.7655 12.2358 14.7681 10.7117 14.7629 9.18753C14.7615 8.81402 14.8881 8.50693 15.2362 8.31767C15.8639 7.978 16.601 8.39413 16.6089 9.10104C16.6221 10.1238 16.6141 11.1466 16.6141 12.1706C16.6141 14.2274 16.6128 16.2843 16.6128 18.3398C16.6128 18.7547 16.4467 19.0756 16.0353 19.241C15.4024 19.4967 14.7695 19.0593 14.7655 18.3624C14.7602 16.8696 14.7629 15.3768 14.7629 13.884C14.7655 13.8439 14.7655 13.8013 14.7655 13.7599Z"
          fill="#898989"
        />
      </svg>
    ),
    [SVG_ICONS.DELETE]: (
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M5.84819 2.91942C5.84819 2.57892 5.8461 2.27497 5.84819 1.97206C5.85863 0.878472 6.67961 0.0292948 7.77425 0.0136273C8.92319 -0.00308466 10.0721 -0.00517366 11.22 0.0115383C12.3283 0.0272058 13.1482 0.875339 13.1618 1.98773C13.1659 2.28959 13.1628 2.59249 13.1628 2.92047C13.2923 2.92047 13.3947 2.92047 13.4971 2.92047C15.046 2.92465 16.595 2.92778 18.144 2.93822C18.3049 2.93927 18.4793 2.96225 18.6224 3.0291C18.9034 3.15861 19.0569 3.50434 18.9995 3.79471C18.9358 4.11955 18.6913 4.36188 18.3561 4.38485C18.027 4.40783 17.6949 4.3953 17.3648 4.39843C17.2625 4.39948 17.1591 4.39843 17.0233 4.39843C16.9909 4.8883 16.9585 5.35311 16.9293 5.81895C16.6943 9.57079 16.4613 13.3216 16.2263 17.0734C16.1167 18.824 14.8706 19.997 13.1158 19.998C10.7135 20.0001 8.31216 20.0012 5.90982 19.998C4.16864 19.9959 2.92464 18.7906 2.81705 17.0504C2.62278 13.9159 2.40865 10.7814 2.20393 7.64787C2.14022 6.67544 2.0671 5.70301 2.02219 4.73058C2.00966 4.45588 1.9167 4.37441 1.65244 4.39426C1.35789 4.41619 1.06125 4.40574 0.765658 4.39634C0.314435 4.38277 0.00421848 4.08404 4.04814e-05 3.67251C-0.00413751 3.25053 0.315479 2.93927 0.776103 2.93613C2.35121 2.92673 3.92631 2.92465 5.50142 2.92047C5.60482 2.91942 5.70927 2.91942 5.84819 2.91942ZM15.5453 4.44021C11.5125 4.44021 7.52357 4.44021 3.52314 4.44021C3.52314 4.58018 3.51582 4.71701 3.52418 4.85383C3.58163 5.80015 3.64639 6.74647 3.70174 7.69278C3.88349 10.8106 4.06105 13.9284 4.24279 17.0463C4.29398 17.9163 4.91336 18.5274 5.78448 18.5305C8.26412 18.5389 10.7438 18.5378 13.2234 18.5274C14.082 18.5242 14.7035 17.9236 14.7609 17.0672C14.857 15.6268 14.9437 14.1854 15.0335 12.744C15.1683 10.5913 15.304 8.43751 15.4377 6.2848C15.4764 5.68734 15.5077 5.08989 15.5453 4.44021ZM11.6974 2.90167C11.6974 2.58727 11.7026 2.29272 11.6953 1.99922C11.688 1.70049 11.524 1.53546 11.2232 1.52397C10.9798 1.51562 10.7364 1.52084 10.4931 1.52084C9.6063 1.52084 8.71847 1.51875 7.83169 1.52293C7.52357 1.52397 7.33451 1.66707 7.31989 1.92819C7.30213 2.24677 7.31571 2.56743 7.31571 2.90062C8.77905 2.90167 10.2194 2.90167 11.6974 2.90167Z"
          fill="#F23A4B"
        />
        <path
          d="M5.84836 11.4383C5.84836 10.186 5.84732 8.9336 5.84836 7.68124C5.84836 7.16944 6.13038 6.8446 6.5722 6.84042C7.01298 6.83415 7.31171 7.16213 7.31171 7.66662C7.3138 10.2068 7.31275 12.746 7.31066 15.2862C7.31066 15.7646 7.00149 16.0968 6.57325 16.0926C6.14709 16.0884 5.84941 15.7563 5.84836 15.2737C5.84732 13.9952 5.84836 12.7168 5.84836 11.4383Z"
          fill="#F23A4B"
        />
        <path
          d="M10.236 11.4676C10.236 12.7377 10.2349 14.0078 10.237 15.2769C10.2381 15.5996 10.1242 15.8576 9.8328 16.0101C9.35233 16.2618 8.79457 15.9203 8.77472 15.3604C8.76219 14.9865 8.77263 14.6126 8.77263 14.2387C8.77263 12.0473 8.77263 9.85489 8.77263 7.66353C8.77263 7.26453 8.94811 6.98461 9.25624 6.88016C9.7576 6.7099 10.2308 7.05459 10.2328 7.60504C10.2402 8.8929 10.236 10.1797 10.236 11.4676Z"
          fill="#F23A4B"
        />
        <path
          d="M11.6962 11.4666C11.6962 10.1965 11.6983 8.92639 11.6941 7.65627C11.6931 7.34501 11.7934 7.08911 12.0691 6.93139C12.5663 6.64833 13.1502 6.99511 13.1564 7.5842C13.1669 8.43651 13.1606 9.28883 13.1606 10.1422C13.1606 11.8562 13.1596 13.5702 13.1596 15.2832C13.1596 15.6289 13.028 15.8963 12.7021 16.0342C12.2007 16.2473 11.6993 15.8827 11.6962 15.302C11.692 14.058 11.6941 12.814 11.6941 11.57C11.6962 11.5366 11.6962 11.5011 11.6962 11.4666Z"
          fill="#F23A4B"
        />
      </svg>
    ),
    [SVG_ICONS.DEVIATION]: (
      <svg
        width="20"
        height="22"
        viewBox="0 0 20 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <g clipPath="url(#clip0_12558:4767)">
          <path
            d="M9.25 12V6.75C9.25 6.34 9.59 6 10 6C10.41 6 10.75 6.34 10.75 6.75V12C10.75 12.41 10.41 12.75 10 12.75C9.59 12.75 9.25 12.41 9.25 12Z"
            fill="#fff"
          />
          <path
            d="M9.28998 15.9602C9.19998 15.8602 9.13001 15.7502 9.07001 15.6302C9.02001 15.5102 9 15.3802 9 15.2502C9 14.9902 9.10998 14.7302 9.28998 14.5402C9.65998 14.1702 10.34 14.1702 10.71 14.5402C10.89 14.7302 11 14.9902 11 15.2502C11 15.3802 10.97 15.5102 10.92 15.6302C10.87 15.7502 10.8 15.8602 10.71 15.9602C10.52 16.1502 10.27 16.2502 10 16.2502C9.73 16.2502 9.47998 16.1502 9.28998 15.9602Z"
            fill="#fff"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.05017 21.2301L2.11017 17.8001C0.910168 17.1001 0.160156 15.8101 0.160156 14.4201V7.58011C0.160156 6.19011 0.910168 4.90011 2.11017 4.20011L8.05017 0.770117C9.25017 0.0701172 10.7402 0.0701172 11.9502 0.770117L17.8902 4.20011C19.0902 4.90011 19.8402 6.19011 19.8402 7.58011V14.4201C19.8402 15.8101 19.0902 17.1001 17.8902 17.8001L11.9502 21.2301C11.3502 21.5801 10.6702 21.7501 10.0002 21.7501C9.33018 21.7501 8.65017 21.5801 8.05017 21.2301ZM8.80017 2.07011L2.86017 5.5001C2.12017 5.9301 1.66016 6.72011 1.66016 7.58011V14.4201C1.66016 15.2701 2.12017 16.0701 2.86017 16.5001L8.80017 19.9301C9.54017 20.3601 10.4602 20.3601 11.1902 19.9301L17.1302 16.5001C17.8702 16.0701 18.3302 15.2801 18.3302 14.4201V7.58011C18.3302 6.73011 17.8702 5.9301 17.1302 5.5001L11.1902 2.07011C10.8302 1.86011 10.4102 1.7501 10.0002 1.7501C9.59018 1.7501 9.17017 1.86011 8.80017 2.07011Z"
            fill="#fff"
          />
        </g>
        <defs>
          <clipPath id="clip0_12558:4767">
            <rect width="20" height="22" fill="white" />
          </clipPath>
        </defs>
      </svg>
    ),
    [SVG_ICONS.GLOBAL]: (
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <g clipPath="url(#clip0_15069_6111)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.00027 15.273C3.98365 15.273 0.727539 12.0169 0.727539 8.00027C0.727539 3.98365 3.98365 0.727539 8.00027 0.727539C12.0169 0.727539 15.273 3.98365 15.273 8.00027C15.273 12.0169 12.0169 15.273 8.00027 15.273Z"
            stroke="#7D7D7D"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M5.09125 1.45459H5.81852C4.40034 5.70186 4.40034 10.2982 5.81852 14.5455H5.09125"
            stroke="#7D7D7D"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M10.1821 1.45459C11.6003 5.70186 11.6003 10.2982 10.1821 14.5455"
            stroke="#7D7D7D"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M1.45459 10.9094V10.1821C5.70186 11.6003 10.2982 11.6003 14.5455 10.1821V10.9094"
            stroke="#7D7D7D"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M1.45459 5.81852C5.70186 4.40034 10.2982 4.40034 14.5455 5.81852"
            stroke="#7D7D7D"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_15069_6111">
            <rect width="16" height="16" fill="white" />
          </clipPath>
        </defs>
      </svg>
    ),
    [SVG_ICONS.USER]: (
      <svg
        width="15"
        height="16"
        viewBox="0 0 15 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <g clipPath="url(#clip0_15069_6129)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.27259 8.00027C5.26429 8.00027 3.63623 6.37221 3.63623 4.3639C3.63623 2.35559 5.26429 0.727539 7.27259 0.727539C9.2809 0.727539 10.909 2.35559 10.909 4.3639C10.909 6.37221 9.2809 8.00027 7.27259 8.00027Z"
            stroke="#7D7D7D"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M13.5199 15.273C13.5199 12.4585 10.7199 10.1821 7.27266 10.1821C3.82539 10.1821 1.02539 12.4585 1.02539 15.273"
            stroke="#7D7D7D"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_15069_6129">
            <rect width="14.5455" height="16" fill="white" />
          </clipPath>
        </defs>
      </svg>
    ),
    [SVG_ICONS.LINK]: (
      <svg
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M12 9.9998L20.2 1.7998"
          stroke="#0095E9"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M21.0002 5.8V1H16.2002"
          stroke="#0095E9"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10 1H8C3 1 1 3 1 8V14C1 19 3 21 8 21H14C19 21 21 19 21 14V12"
          stroke="#0095E9"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
    [SVG_ICONS.EDIT]: (
      <svg
        width="18"
        height="20"
        viewBox="0 0 18 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <g clipPath="url(#clip0_12332:5406)">
          <path
            d="M13.8328 8.33603L15.0388 7.04512C16.3168 5.68149 16.8928 4.12694 14.9038 2.22694C12.9148 0.336031 11.4118 0.999667 10.1338 2.3633L2.74482 10.2633C2.46582 10.5633 2.19582 11.1542 2.14182 11.5633L1.80882 14.5088C1.69182 15.5724 2.44782 16.2997 3.49182 16.1179L6.38982 15.6179C6.79482 15.5451 7.36182 15.2451 7.64082 14.936L13.8958 8.40876"
            stroke="#212121"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M8.90234 3.68164C9.28934 6.19073 11.3053 8.10891 13.8073 8.36346"
            stroke="#212121"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M0.902344 19.0908H14.4023"
            stroke="#212121"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M14.4023 19.0908H17.1023"
            stroke="#212121"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_12332:5406">
            <rect width="18" height="20" fill="white" />
          </clipPath>
        </defs>
      </svg>
    ),
    [SVG_ICONS.SETTING]: (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M12 15.75C9.93 15.75 8.25 14.07 8.25 12C8.25 9.93 9.93 8.25 12 8.25C14.07 8.25 15.75 9.93 15.75 12C15.75 14.07 14.07 15.75 12 15.75ZM12 9.75C10.76 9.75 9.75 10.76 9.75 12C9.75 13.24 10.76 14.25 12 14.25C13.24 14.25 14.25 13.24 14.25 12C14.25 10.76 13.24 9.75 12 9.75Z"
          fill="#fff"
        />
        <path
          d="M15.21 22.1898C15 22.1898 14.79 22.1598 14.58 22.1098C13.96 21.9398 13.44 21.5498 13.11 20.9998L12.99 20.7998C12.4 19.7798 11.59 19.7798 11 20.7998L10.89 20.9898C10.56 21.5498 10.04 21.9498 9.42 22.1098C8.79 22.2798 8.14 22.1898 7.59 21.8598L5.87 20.8698C5.26 20.5198 4.82 19.9498 4.63 19.2598C4.45 18.5698 4.54 17.8598 4.89 17.2498C5.18 16.7398 5.26 16.2798 5.09 15.9898C4.92 15.6998 4.49 15.5298 3.9 15.5298C2.44 15.5298 1.25 14.3398 1.25 12.8798V11.1198C1.25 9.6598 2.44 8.4698 3.9 8.4698C4.49 8.4698 4.92 8.2998 5.09 8.0098C5.26 7.7198 5.19 7.2598 4.89 6.7498C4.54 6.1398 4.45 5.4198 4.63 4.7398C4.81 4.0498 5.25 3.4798 5.87 3.1298L7.6 2.1398C8.73 1.4698 10.22 1.8598 10.9 3.0098L11.02 3.2098C11.61 4.2298 12.42 4.2298 13.01 3.2098L13.12 3.0198C13.8 1.8598 15.29 1.4698 16.43 2.1498L18.15 3.1398C18.76 3.4898 19.2 4.0598 19.39 4.7498C19.57 5.4398 19.48 6.1498 19.13 6.7598C18.84 7.2698 18.76 7.7298 18.93 8.0198C19.1 8.3098 19.53 8.4798 20.12 8.4798C21.58 8.4798 22.77 9.6698 22.77 11.1298V12.8898C22.77 14.3498 21.58 15.5398 20.12 15.5398C19.53 15.5398 19.1 15.7098 18.93 15.9998C18.76 16.2898 18.83 16.7498 19.13 17.2598C19.48 17.8698 19.58 18.5898 19.39 19.2698C19.21 19.9598 18.77 20.5298 18.15 20.8798L16.42 21.8698C16.04 22.0798 15.63 22.1898 15.21 22.1898ZM12 18.4898C12.89 18.4898 13.72 19.0498 14.29 20.0398L14.4 20.2298C14.52 20.4398 14.72 20.5898 14.96 20.6498C15.2 20.7098 15.44 20.6798 15.64 20.5598L17.37 19.5598C17.63 19.4098 17.83 19.1598 17.91 18.8598C17.99 18.5598 17.95 18.2498 17.8 17.9898C17.23 17.0098 17.16 15.9998 17.6 15.2298C18.04 14.4598 18.95 14.0198 20.09 14.0198C20.73 14.0198 21.24 13.5098 21.24 12.8698V11.1098C21.24 10.4798 20.73 9.9598 20.09 9.9598C18.95 9.9598 18.04 9.5198 17.6 8.7498C17.16 7.9798 17.23 6.9698 17.8 5.9898C17.95 5.7298 17.99 5.4198 17.91 5.1198C17.83 4.8198 17.64 4.5798 17.38 4.4198L15.65 3.4298C15.22 3.1698 14.65 3.3198 14.39 3.7598L14.28 3.9498C13.71 4.9398 12.88 5.4998 11.99 5.4998C11.1 5.4998 10.27 4.9398 9.7 3.9498L9.59 3.7498C9.34 3.3298 8.78 3.1798 8.35 3.4298L6.62 4.4298C6.36 4.5798 6.16 4.8298 6.08 5.1298C6 5.4298 6.04 5.7398 6.19 5.9998C6.76 6.9798 6.83 7.9898 6.39 8.7598C5.95 9.5298 5.04 9.9698 3.9 9.9698C3.26 9.9698 2.75 10.4798 2.75 11.1198V12.8798C2.75 13.5098 3.26 14.0298 3.9 14.0298C5.04 14.0298 5.95 14.4698 6.39 15.2398C6.83 16.0098 6.76 17.0198 6.19 17.9998C6.04 18.2598 6 18.5698 6.08 18.8698C6.16 19.1698 6.35 19.4098 6.61 19.5698L8.34 20.5598C8.55 20.6898 8.8 20.7198 9.03 20.6598C9.27 20.5998 9.47 20.4398 9.6 20.2298L9.71 20.0398C10.28 19.0598 11.11 18.4898 12 18.4898Z"
          fill="#fff"
        />
      </svg>
    ),
    [SVG_ICONS.DOWNLOAD]: (
      <svg
        viewBox="0 0 25 24"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path d="M11.1411 15.8454C11.1411 14.6139 11.1411 13.3813 11.1411 12.1498C11.1411 8.41748 11.1424 4.68637 11.1399 0.954045C11.1399 0.6015 11.2537 0.312609 11.5647 0.127767C11.8523 -0.0423846 12.1498 -0.0436087 12.435 0.130216C12.7423 0.316281 12.8586 0.605172 12.8586 0.957718C12.8561 2.91508 12.8573 4.87366 12.8573 6.83102C12.8573 9.74686 12.8573 12.6639 12.8586 15.5798C12.8586 15.6679 12.8586 15.756 12.8586 15.8454C12.8843 15.8638 12.9112 15.8809 12.9369 15.8993C13.3715 15.4476 13.7999 14.991 14.2406 14.5466C15.2676 13.5122 16.2983 12.4815 17.3315 11.4521C17.8554 10.9306 18.6535 11.1166 18.8261 11.8009C18.9155 12.1535 18.7784 12.4362 18.5311 12.6823C17.3768 13.8342 16.2237 14.9885 15.0705 16.1416C14.292 16.9202 13.5122 17.6975 12.7349 18.4773C12.2294 18.984 11.7703 18.9804 11.2599 18.4699C9.33556 16.5444 7.41003 14.6201 5.48572 12.6958C4.93977 12.1498 5.09645 11.359 5.79175 11.1742C6.15776 11.0763 6.44298 11.2244 6.6976 11.4802C8.10165 12.8879 9.50939 14.292 10.9134 15.6997C10.9698 15.756 11.0065 15.8332 11.053 15.8993C11.0811 15.8821 11.1105 15.8638 11.1411 15.8454Z" />
        <path d="M22.2805 22.2597C22.2805 21.1274 22.2756 20.0171 22.2829 18.9056C22.2878 18.2079 22.9415 17.7917 23.5315 18.1002C23.8277 18.2556 23.9906 18.5127 23.993 18.8408C24.0003 20.0233 24.0163 21.207 23.9844 22.3895C23.9599 23.299 23.1973 23.9882 22.2621 23.9943C20.9572 24.0029 19.6511 23.9967 18.3462 23.9967C12.8793 23.9967 7.41358 23.9967 1.94669 23.9967C0.677278 23.9967 0.00156687 23.321 0.00156687 22.0528C0.00156687 21.0025 -0.000881363 19.9523 0.000342752 18.902C0.000342752 18.5604 0.134995 18.2875 0.437352 18.1149C0.728691 17.9484 1.02493 17.9508 1.3077 18.1296C1.59904 18.3144 1.71778 18.5935 1.71655 18.935C1.7141 19.9339 1.71655 20.934 1.71655 21.9329C1.71655 22.0333 1.71655 22.1349 1.71655 22.2585C8.57037 22.2597 15.4071 22.2597 22.2805 22.2597Z" />
      </svg>
    ),
    [SVG_ICONS.DOWNLOAD_OUTLINE]: (
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.49935 18.3329H12.4993C16.666 18.3329 18.3327 16.6663 18.3327 12.4996V7.49959C18.3327 3.33293 16.666 1.66626 12.4993 1.66626H7.49935C3.33268 1.66626 1.66602 3.33293 1.66602 7.49959V12.4996C1.66602 16.6663 3.33268 18.3329 7.49935 18.3329Z"
          stroke="#292D32"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.5 11.2578L10 13.7578L12.5 11.2578"
          stroke="#292D32"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10 13.7585V7.0918"
          stroke="#292D32"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
    [SVG_ICONS.CLOSE]: (
      <svg
        width="56"
        height="56"
        viewBox="0 0 56 56"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M16.4091 39.5909C16.9545 40.1364 17.7727 40.1364 18.3182 39.5909L39.5909 18.3182C40.1364 17.7727 40.1364 16.9545 39.5909 16.4091C39.0455 15.8636 38.2273 15.8636 37.6818 16.4091L16.4091 37.6818C15.8636 38.2273 15.8636 39.0455 16.4091 39.5909Z"
          fill="black"
        />
        <path
          d="M39.5909 39.5909C40.1364 39.0455 40.1364 38.2273 39.5909 37.6818L18.3182 16.4091C17.7727 15.8636 16.9545 15.8636 16.4091 16.4091C15.8636 16.9545 15.8636 17.7727 16.4091 18.3182L37.6818 39.5909C38.2273 40.1364 39.0455 40.1364 39.5909 39.5909Z"
          fill="black"
        />
      </svg>
    ),
    [SVG_ICONS.RESOLVE]: (
      <svg
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M8 21H14C19 21 21 19 21 14V8C21 3 19 1 14 1H8C3 1 1 3 1 8V14C1 19 3 21 8 21Z"
          stroke="#7D7D7D"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.75 10.9999L9.58 13.8299L15.25 8.16992"
          stroke="#7D7D7D"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
    [SVG_ICONS.IGNORE]: (
      <svg
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M8 21H14C19 21 21 19 21 14V8C21 3 19 1 14 1H8C3 1 1 3 1 8V14C1 19 3 21 8 21Z"
          stroke="#7D7D7D"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.99778 10.9998H15.0022"
          stroke="#7D7D7D"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
    [SVG_ICONS.MORE]: (
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <circle cx="16" cy="16" r="16" fill="white" />
        <circle cx="16" cy="16" r="2" fill="#212121" />
        <circle cx="9" cy="16" r="2" fill="#212121" />
        <circle cx="23" cy="16" r="2" fill="#212121" />
      </svg>
    ),
    [SVG_ICONS.MORE_ACTIVE]: (
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <circle cx="16" cy="16" r="16" fill={theme.palette.primary.main} />
        <circle cx="16" cy="16" r="2" fill="white" />
        <circle cx="9" cy="16" r="2" fill="white" />
        <circle cx="23" cy="16" r="2" fill="white" />
      </svg>
    ),
    [SVG_ICONS.ADD_OUTLINE]: (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M16 12.8002H7.99995C7.59995 12.8002 7.19995 12.5002 7.19995 12.0002C7.19995 11.5002 7.49995 11.2002 7.99995 11.2002H16C16.4 11.2002 16.8 11.5002 16.8 12.0002C16.8 12.5002 16.4 12.8002 16 12.8002Z"
          fill="#212121"
        />
        <path
          d="M12 16.8002C11.6 16.8002 11.2 16.5002 11.2 16.0002V8.0002C11.2 7.6002 11.5 7.2002 12 7.2002C12.5 7.2002 12.8 7.5002 12.8 8.0002V16.0002C12.8 16.4002 12.4 16.8002 12 16.8002Z"
          fill="#212121"
        />
        <path
          d="M15 22.8002H8.99995C3.59995 22.8002 1.19995 20.5002 1.19995 15.0002V9.0002C1.19995 3.6002 3.49995 1.2002 8.99995 1.2002H15C20.4 1.2002 22.7999 3.5002 22.7999 9.0002V15.0002C22.7999 20.4002 20.4 22.8002 15 22.8002ZM8.99995 2.8002C4.39995 2.8002 2.79995 4.4002 2.79995 9.0002V15.0002C2.79995 19.6002 4.39995 21.2002 8.99995 21.2002H15C19.6 21.2002 21.2 19.6002 21.2 15.0002V9.0002C21.2 4.4002 19.6 2.8002 15 2.8002H8.99995Z"
          fill="#212121"
        />
      </svg>
    ),
    [SVG_ICONS.RADIO_INACTIVE]: (
      <svg
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M8 0C3.5888 0 0 3.5888 0 8C0 12.4112 3.5888 16 8 16C12.4112 16 16 12.4112 16 8C16 3.5888 12.4112 0 8 0ZM8 14.5455C4.39079 14.5455 1.45455 11.6092 1.45455 8C1.45455 4.39084 4.39079 1.45455 8 1.45455C11.6092 1.45455 14.5455 4.39084 14.5455 8C14.5455 11.6092 11.6092 14.5455 8 14.5455Z"
          fill="#B8B8B8"
        />
      </svg>
    ),
    [SVG_ICONS.RADIO_UNCHECKED]: (
      <svg
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M8 0C3.5888 0 0 3.5888 0 8C0 12.4112 3.5888 16 8 16C12.4112 16 16 12.4112 16 8C16 3.5888 12.4112 0 8 0ZM8 14.5455C4.39079 14.5455 1.45455 11.6092 1.45455 8C1.45455 4.39084 4.39079 1.45455 8 1.45455C11.6092 1.45455 14.5455 4.39084 14.5455 8C14.5455 11.6092 11.6092 14.5455 8 14.5455Z"
          fill="#212121"
        />
      </svg>
    ),
    [SVG_ICONS.RADIO_CHECKED]: (
      <svg
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M8 0C3.5888 0 0 3.5888 0 8C0 12.4112 3.5888 16 8 16C12.4112 16 16 12.4112 16 8C16 3.5888 12.4112 0 8 0ZM8 14.5455C4.39079 14.5455 1.45455 11.6092 1.45455 8C1.45455 4.39084 4.39079 1.45455 8 1.45455C11.6092 1.45455 14.5455 4.39084 14.5455 8C14.5455 11.6092 11.6092 14.5455 8 14.5455Z"
          fill="#3AC38C"
        />
        <path
          d="M11.003 5.17198L6.88883 9.28606L5.00325 7.40044C4.71927 7.11646 4.25876 7.11641 3.97474 7.40039C3.69071 7.68441 3.69071 8.14487 3.97474 8.4289L6.37455 10.8288C6.51093 10.9652 6.6959 11.0418 6.88878 11.0418C6.88883 11.0418 6.88878 11.0418 6.88883 11.0418C7.0817 11.0418 7.26667 10.9652 7.40306 10.8288L12.0315 6.20053C12.3155 5.91651 12.3155 5.45605 12.0315 5.17203C11.7475 4.888 11.287 4.88795 11.003 5.17198Z"
          fill="#3AC38C"
        />
      </svg>
    ),
    [SVG_ICONS.DOT]: (
      <svg
        width="8"
        height="8"
        viewBox="0 0 8 8"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <circle cx="4" cy="4" r="4" fill="#3AC38C" />
      </svg>
    ),
    [SVG_ICONS.CHECK]: (
      <svg
        width="12"
        height="9"
        viewBox="0 0 12 9"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M10.2437 0.315139L4.4237 6.4022L1.75631 3.6123C1.35458 3.19214 0.703133 3.19206 0.301343 3.61222C-0.100448 4.03246 -0.100448 4.71374 0.301343 5.13397L3.69619 8.68479C3.88913 8.88659 4.15079 9 4.42364 9C4.4237 9 4.42364 9 4.4237 9C4.69655 9 4.95821 8.88659 5.15115 8.68486L11.6987 1.83696C12.1004 1.41673 12.1004 0.735443 11.6987 0.315211C11.2969 -0.105022 10.6455 -0.105094 10.2437 0.315139Z"
          fill="#0095E9"
        />
      </svg>
    ),
    [SVG_ICONS.ADD]: (
      <svg
        width="12"
        height="12"
        viewBox="0 0 12 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M11 4.99998H7.00002V1.00002C7.00002 0.448015 6.55301 0 6 0C5.44699 0 4.99998 0.448015 4.99998 1.00002V4.99998H1.00002C0.447007 4.99998 0 5.448 0 6C0 6.552 0.447007 7.00002 1.00002 7.00002H4.99998V11C4.99998 11.552 5.44699 12 6 12C6.55301 12 7.00002 11.552 7.00002 11V7.00002H11C11.553 7.00002 12 6.552 12 6C12 5.448 11.553 4.99998 11 4.99998Z"
          fill="currentColor"
        />
      </svg>
    ),
    [SVG_ICONS.DELETE_CHIP]: (
      <svg
        viewBox="0 0 16 16"
        fill="#212121"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <rect width="16" height="16" rx="4" fill="#D8F3E8" />
        <path
          d="M10.5 11C10.3721 11 10.2441 10.9511 10.1465 10.8534L5.14652 5.85346C4.95116 5.65811 4.95116 5.34173 5.14652 5.14648C5.34177 4.95123 5.65825 4.95112 5.8535 5.14648L10.8535 10.1464C11.0488 10.3418 11.0488 10.6582 10.8535 10.8534C10.7558 10.9511 10.628 11 10.5 11Z"
          fill="#212121"
        />
        <path
          d="M5.49996 11C5.372 11 5.24414 10.9512 5.14652 10.8535C4.95116 10.6582 4.95116 10.3417 5.14652 10.1465L10.1465 5.14652C10.3418 4.95116 10.6582 4.95116 10.8535 5.14652C11.0487 5.34177 11.0488 5.65825 10.8535 5.8535L5.8535 10.8535C5.75588 10.9512 5.62792 11 5.49996 11Z"
          fill="#212121"
        />
      </svg>
    ),
    [SVG_ICONS.ARROW_RIGHT]: (
      <svg
        width="29"
        viewBox="0 0 29 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M27.5997 10.8002H3.66056L12.8272 2.06907C13.3072 1.61187 13.3258 0.852282 12.8686 0.372288C12.412 -0.107106 11.6525 -0.126306 11.1719 0.330888L0.703191 10.3028C0.250197 10.7564 0 11.3588 0 12.0001C0 12.6409 0.250197 13.2439 0.724191 13.7173L11.1725 23.6688C11.4047 23.8902 11.7023 24 11.9999 24C12.3167 24 12.6334 23.8752 12.8692 23.6274C13.3264 23.1474 13.3078 22.3884 12.8278 21.9312L3.62276 13.2001H27.5997C28.2621 13.2001 28.7996 12.6625 28.7996 12.0001C28.7996 11.3378 28.2621 10.8002 27.5997 10.8002Z"
          fill="black"
        />
      </svg>
    ),
    [SVG_ICONS.SCRIVE]: (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <rect width="24" height="24" rx="2" fill="#27282D" />
        <path
          d="M3 14.7603C3.86402 14.7603 4.67255 14.7603 5.48108 14.7761C5.55854 14.7937 5.63045 14.8301 5.69039 14.8822C5.75032 14.9343 5.79643 15.0005 5.82458 15.0747C6.17864 16.6601 7.32538 17.3312 8.78126 17.6007C10.3138 17.8808 11.8489 17.9072 13.3497 17.421C13.7223 17.2914 14.0739 17.108 14.3934 16.8767C15.0302 16.4223 15.2152 15.7564 15.128 15.0087C15.0933 14.6977 14.9578 14.4067 14.7421 14.18C14.5265 13.9534 14.2425 13.8036 13.9337 13.7536C12.9296 13.5184 11.9071 13.3599 10.8871 13.2093C9.73512 13.0349 8.57517 12.916 7.4205 12.7548C5.4758 12.4906 3.94857 11.1959 3.62357 9.5841C3.44327 8.73744 3.53499 7.85546 3.88564 7.06401C4.23629 6.27256 4.82795 5.61209 5.5762 5.17681C6.72425 4.51691 8.01124 4.13588 9.33349 4.06442C11.112 3.87387 12.9103 4.10749 14.581 4.74612C16.4306 5.49917 17.646 7.20607 17.5906 8.97374H14.9272C14.478 6.98148 12.9243 6.45038 11.1461 6.27071C9.93065 6.14652 8.72578 6.20465 7.59753 6.75424C7.31097 6.87206 7.0555 7.0545 6.85109 7.28734C6.64667 7.52018 6.49882 7.7971 6.41908 8.09651C6.17335 9.13227 6.63047 9.94609 7.74021 10.1522C9.48411 10.4851 11.2597 10.6621 13.0089 10.9871C14.0658 11.18 15.1597 11.3623 16.0845 11.8432C18.3515 13.019 18.6686 16.1871 16.8084 18.0658C15.8387 19.0434 14.618 19.5137 13.2916 19.7357C11.0325 20.1135 8.77862 20.1531 6.57762 19.408C4.42154 18.6735 3.21931 17.1647 3 14.7603Z"
          fill="white"
        />
        <path
          d="M19.8755 19.9561C19.3992 19.9566 18.9412 19.7733 18.5966 19.4446C18.2521 19.1158 18.0477 18.6668 18.0259 18.191C18.0238 17.7126 18.2115 17.2529 18.5478 16.9126C18.8841 16.5723 19.3416 16.3793 19.82 16.3758C20.2953 16.3922 20.7468 16.588 21.0836 16.9238C21.4204 17.2596 21.6175 17.7105 21.6352 18.1857C21.6318 18.6524 21.4456 19.0991 21.1167 19.43C20.7877 19.761 20.3421 19.9498 19.8755 19.9561Z"
          fill="white"
        />
      </svg>
    ),
    [SVG_ICONS.WARNING]: (
      <svg
        width="18"
        viewBox="0 0 18 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.64092 0.0362694C8.8067 -0.012112 8.98286 -0.0120893 9.14862 0.0363347L17.1299 2.36783C17.5162 2.48066 17.7817 2.83481 17.7817 3.23722V8.01856C17.7817 13.434 14.316 18.2417 9.17831 19.9536C8.99248 20.0155 8.79159 20.0155 8.60576 19.9536C3.46671 18.2418 0 13.433 0 8.01634V3.23722C0 2.83473 0.265608 2.48052 0.651979 2.36777L8.64092 0.0362694ZM1.81144 3.91639V8.01634C1.81144 12.5519 4.65079 16.5895 8.89195 18.1352C13.1319 16.5895 15.9702 12.5529 15.9702 8.01856V3.91621L8.89454 1.84926L1.81144 3.91639Z"
          fill="#FFC700"
        />
        <path
          d="M7.79699 5.88369C7.74469 5.15142 8.32464 4.52856 9.05878 4.52856V4.52856C9.79291 4.52856 10.3729 5.15142 10.3206 5.88369L10.029 9.96519C9.99267 10.4742 9.5691 10.8686 9.05878 10.8686V10.8686C8.54845 10.8686 8.12488 10.4742 8.08853 9.96519L7.79699 5.88369Z"
          fill="#FFC700"
        />
        <circle cx="9.10481" cy="13.9061" r="1.13215" fill="#FFC700" />
      </svg>
    ),
    [SVG_ICONS.XLSX]: (
      <svg
        width="16"
        height="20"
        viewBox="0 0 16 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M14.9323 6.43851H14.5V4.35303C14.5 4.34003 14.498 4.32693 14.4965 4.31364C14.4958 4.23091 14.4692 4.14959 14.4125 4.08514L10.9419 0.120713C10.9408 0.119696 10.9398 0.119334 10.9391 0.118251C10.9184 0.0951393 10.8943 0.0759013 10.8688 0.0592897C10.8612 0.054234 10.8536 0.049999 10.8457 0.0455342C10.8236 0.0335515 10.8002 0.0234729 10.7761 0.0162177C10.7695 0.0145105 10.7636 0.0118185 10.7571 0.0101114C10.7309 0.00387386 10.7037 0 10.6761 0H2.14694C1.75748 0 1.44107 0.31677 1.44107 0.705895V6.43831H1.00891C0.451764 6.43831 0 6.88991 0 7.44726V12.6938C0 13.2506 0.451764 13.7026 1.00891 13.7026H1.44107V17.2941C1.44107 17.6833 1.75748 18 2.14694 18H13.794C14.1831 18 14.4998 17.6833 14.4998 17.2941V13.7027H14.9321C15.4891 13.7027 15.9409 13.2508 15.9409 12.6938V7.44745C15.9409 6.88995 15.4894 6.43851 14.9323 6.43851ZM2.14694 0.705895H10.3232V4.31731C10.3232 4.51232 10.4813 4.67026 10.6761 4.67026H13.794V6.43848H2.14694V0.705895ZM9.29778 10.3301C8.60429 10.0885 8.15177 9.70486 8.15177 9.09755C8.15177 8.38522 8.74631 7.84029 9.73139 7.84029C10.2019 7.84029 10.5489 7.93924 10.7964 8.05082L10.586 8.81246C10.4188 8.73216 10.1216 8.61427 9.71277 8.61427C9.30398 8.61427 9.10582 8.80015 9.10582 9.01696C9.10582 9.28337 9.34124 9.40093 9.87994 9.60529C10.6168 9.87794 10.9637 10.2619 10.9637 10.8502C10.9637 11.5502 10.4248 12.1448 9.279 12.1448C8.80219 12.1448 8.33151 12.0211 8.09613 11.8908L8.28795 11.1105C8.54198 11.2404 8.93229 11.3707 9.33471 11.3707C9.76865 11.3707 9.99747 11.1911 9.99747 10.9185C9.99763 10.6586 9.79947 10.5096 9.29778 10.3301ZM7.70034 11.29V12.083H5.09241V7.90798H6.04042V11.29H7.70034ZM2.06421 12.083H0.986553L2.19428 9.97038L1.02972 7.90782H2.11378L2.479 8.66979C2.6029 8.92375 2.69587 9.12789 2.79508 9.36363H2.80713C2.90651 9.09722 2.98694 8.91141 3.09193 8.66979L3.44504 7.90782H4.52273L3.34586 9.9454L4.58484 12.0827H3.49484L3.11681 11.3269C2.96222 11.0362 2.86304 10.8192 2.74532 10.5776H2.733C2.64617 10.8192 2.54112 11.0362 2.41092 11.3269L2.06421 12.083ZM13.794 17.103H2.14694V13.7027H13.794V17.103H13.794ZM13.8004 12.083L13.4224 11.3273C13.2677 11.0363 13.1686 10.8195 13.0509 10.5779H13.0388C12.952 10.8195 12.8465 11.0363 12.7162 11.3273L12.3698 12.083H11.2919L12.4996 9.97038L11.3351 7.90782H12.4191L12.7848 8.66979C12.9086 8.92375 13.0012 9.12789 13.1006 9.36363H13.1129C13.2118 9.09722 13.2921 8.91141 13.3976 8.66979L13.7506 7.90782H14.8285L13.6516 9.9454L14.8904 12.0827H13.8004V12.083Z"
          fill="#20A777"
        />
      </svg>
    ),
    [SVG_ICONS.UPLOAD_WHITE]: (
      <svg
        width="24"
        viewBox="0 0 77 52"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M36.3382 51.9832C28.8677 51.9832 23.3937 52.0261 15.9233 51.9689C9.33891 51.9189 4.41937 48.9643 1.52552 43.0301C-2.75095 34.2628 2.36509 23.6413 11.8684 21.3691C12.5186 21.2119 12.7758 20.9547 12.9151 20.2973C15.6054 7.62866 25.9203 -1.28154 38.7461 0.151094C47.6099 1.14072 52.28 5.53866 56.8602 13.1699C57.0317 13.4557 57.4818 13.7379 57.8105 13.7486C67.6674 14.0809 76.3526 22.5409 76.0489 33.5126C75.7845 43.1266 67.9568 51.358 58.3571 51.8653C54.32 52.0796 52.265 51.9653 48.2172 51.9796C44.2587 51.9939 40.2967 51.9832 36.3382 51.9832ZM40.4217 47.2208C40.611 47.2458 40.754 47.2816 40.8969 47.2816C47.1169 47.2744 51.3404 47.3709 57.5604 47.2208C65.1452 47.0386 71.2437 40.6972 71.3687 33.1017C71.5045 24.9703 64.8736 18.3002 56.7208 18.4752C55.0024 18.511 53.977 17.9465 53.2018 16.396C49.204 8.42894 42.7939 3.9131 33.9052 4.85985C24.2018 5.89235 18.5135 13.3771 17.1559 23.1125C16.9094 24.8667 16.2877 25.4562 14.4943 25.6348C7.942 26.2886 3.37972 32.7909 5.04815 39.1073C6.3486 44.034 10.4929 47.2387 15.7804 47.2708C22.8328 47.3173 27.8888 47.2851 34.9448 47.2816C35.1735 47.2816 35.4021 47.2423 35.6343 47.2208C35.6343 42.287 35.6343 37.4103 35.6343 32.3121C33.9659 34.0056 32.4475 35.5525 30.9149 37.0924C29.8752 38.1391 28.4247 38.2356 27.478 37.346C26.4776 36.4064 26.4776 34.913 27.5351 33.8484C30.4468 30.9117 33.3729 27.9857 36.3131 25.0739C37.3957 24.0021 38.7104 24.0093 39.7965 25.0882C42.7118 27.9821 45.6128 30.8866 48.5066 33.8055C49.582 34.888 49.6141 36.3349 48.6388 37.3031C47.6921 38.2463 46.2237 38.1499 45.1412 37.0709C43.8157 35.7455 42.4903 34.4164 41.1648 33.0945C40.9505 32.8802 40.7182 32.6873 40.4253 32.4193C40.4217 37.4532 40.4217 42.3227 40.4217 47.2208Z"
          fill="#F0F0F0"
        />
      </svg>
    ),
    [SVG_ICONS.UPLOAD_OUTLINED]: (
      <svg
        width="24px"
        viewBox="0 0 58 58"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M21.0691 27.227L27.7705 21.0321V40.5924C27.7705 41.2701 28.3198 41.8193 28.9974 41.8193C29.6746 41.8193 30.2244 41.2701 30.2244 40.5924V21.0321L36.9254 27.227C37.2469 27.5275 37.7046 27.633 38.125 27.5036C38.5457 27.3737 38.8644 27.0286 38.9608 26.5997C39.0571 26.1703 38.9162 25.7222 38.5913 25.425L29.8299 17.326C29.3598 16.8913 28.6347 16.8913 28.1645 17.326L19.4032 25.4255C19.0763 25.7217 18.9335 26.1708 19.0293 26.6016C19.1252 27.0325 19.4453 27.3785 19.8671 27.5079C20.2888 27.6373 20.748 27.5299 21.0691 27.227Z"
          fill="#A3EED0"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M29 58C45.0163 58 58 45.0163 58 29C58 12.9837 45.0163 0 29 0C12.9837 0 0 12.9837 0 29C0 45.0163 12.9837 58 29 58ZM29 56C43.9117 56 56 43.9117 56 29C56 14.0883 43.9117 2 29 2C14.0883 2 2 14.0883 2 29C2 43.9117 14.0883 56 29 56Z"
          fill="#A3EED0"
        />
      </svg>
    ),
    [SVG_ICONS.UPLOAD_GREEN]: (
      <svg
        viewBox="0 0 58 58"
        fill="none"
        width="24px"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <circle cx="29" cy="29" r="29" fill="#3AC38C" />
        <path
          d="M20.2474 27.1087L27.5266 20.3797V41.6262C27.5266 42.3623 28.1232 42.9589 28.8593 42.9589C29.5949 42.9589 30.192 42.3623 30.192 41.6262V20.3797L37.4707 27.1087C37.82 27.4351 38.3171 27.5496 38.7737 27.4091C39.2307 27.268 39.5769 26.8932 39.6815 26.4272C39.7862 25.9608 39.6331 25.4741 39.2802 25.1513L29.7635 16.3541C29.2529 15.882 28.4652 15.882 27.9545 16.3541L18.4379 25.1518C18.0829 25.4736 17.9277 25.9613 18.0319 26.4293C18.136 26.8973 18.4837 27.2732 18.9418 27.4137C19.3999 27.5543 19.8986 27.4377 20.2474 27.1087Z"
          fill="white"
        />
      </svg>
    ),
    [SVG_ICONS.UPLOAD_FILE]: (
      <svg
        width="64"
        viewBox="0 0 64 64"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <g clipPath="url(#clip0)">
          <path
            d="M41.2388 0.36963C40.9454 0.0605472 40.543 -0.125 40.126 -0.125H15.1597C10.5527 -0.125 6.75 3.6626 6.75 8.26906V55.4806C6.75 60.0875 10.5527 63.8751 15.1597 63.8751H49.0455C53.6524 63.8751 57.4552 60.0875 57.4552 55.4806V17.9927C57.4552 17.5909 57.2696 17.2046 57.0069 16.9107L41.2388 0.36963ZM41.6871 5.33204L52.2457 16.416H45.3819C43.3414 16.416 41.6871 14.7774 41.6871 12.7368V5.33204ZM49.0455 60.7833H15.1597C12.2691 60.7833 9.8418 58.3873 9.8418 55.4806V8.26906C9.8418 5.37843 12.2534 2.9668 15.1597 2.9668H38.5953V12.7368C38.5953 16.4932 41.6255 19.5078 45.3819 19.5078H54.3634V55.4806C54.3634 58.3873 51.9517 60.7833 49.0455 60.7833Z"
            fill="#7D7D7D"
          />
          <path
            d="M44.8248 50.1169H19.3794C18.5293 50.1169 17.8335 50.8123 17.8335 51.6629C17.8335 52.513 18.5293 53.2088 19.3794 53.2088H44.8404C45.6905 53.2088 46.3863 52.513 46.3863 51.6629C46.3863 50.8123 45.6905 50.1169 44.8248 50.1169Z"
            fill="#7D7D7D"
          />
          <path
            d="M24.1872 33.4829L30.5563 26.6343V43.5157C30.5563 44.3658 31.2521 45.0616 32.1022 45.0616C32.9528 45.0616 33.6481 44.3658 33.6481 43.5157V26.6343L40.0173 33.4829C40.3263 33.8072 40.7287 33.9776 41.1457 33.9776C41.5168 33.9776 41.9035 33.8384 42.1969 33.5601C42.8156 32.9727 42.862 31.9986 42.2746 31.3804L33.2155 21.6567C32.9215 21.3477 32.5197 21.1621 32.0871 21.1621C31.654 21.1621 31.2521 21.3477 30.9587 21.6567L21.8996 31.3804C21.3122 31.9986 21.3585 32.9878 21.9767 33.5601C22.6261 34.1475 23.5998 34.1011 24.1872 33.4829Z"
            fill="#7D7D7D"
          />
        </g>
        <defs>
          <clipPath id="clip0">
            <rect width="64" height="64" fill="white" />
          </clipPath>
        </defs>
      </svg>
    ),
    [SVG_ICONS.UPLOAD_ACTIVE]: (
      <svg
        viewBox="0 0 77 52"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M36.3382 51.9832C28.8677 51.9832 23.3937 52.0261 15.9233 51.9689C9.33891 51.9189 4.41937 48.9643 1.52552 43.0301C-2.75095 34.2628 2.36509 23.6413 11.8684 21.3691C12.5186 21.2119 12.7758 20.9547 12.9151 20.2973C15.6054 7.62866 25.9203 -1.28154 38.7461 0.151094C47.6099 1.14072 52.28 5.53866 56.8602 13.1699C57.0317 13.4557 57.4818 13.7379 57.8105 13.7486C67.6674 14.0809 76.3526 22.5409 76.0489 33.5126C75.7845 43.1266 67.9568 51.358 58.3571 51.8653C54.32 52.0796 52.265 51.9653 48.2172 51.9796C44.2587 51.9939 40.2967 51.9832 36.3382 51.9832ZM40.4217 47.2208C40.611 47.2458 40.754 47.2816 40.8969 47.2816C47.1169 47.2744 51.3404 47.3709 57.5604 47.2208C65.1452 47.0386 71.2437 40.6972 71.3687 33.1017C71.5045 24.9703 64.8736 18.3002 56.7208 18.4752C55.0024 18.511 53.977 17.9465 53.2018 16.396C49.204 8.42894 42.7939 3.9131 33.9052 4.85985C24.2018 5.89235 18.5135 13.3771 17.1559 23.1125C16.9094 24.8667 16.2877 25.4562 14.4943 25.6348C7.942 26.2886 3.37972 32.7909 5.04815 39.1073C6.3486 44.034 10.4929 47.2387 15.7804 47.2708C22.8328 47.3173 27.8888 47.2851 34.9448 47.2816C35.1735 47.2816 35.4021 47.2423 35.6343 47.2208C35.6343 42.287 35.6343 37.4103 35.6343 32.3121C33.9659 34.0056 32.4475 35.5525 30.9149 37.0924C29.8752 38.1391 28.4247 38.2356 27.478 37.346C26.4776 36.4064 26.4776 34.913 27.5351 33.8484C30.4468 30.9117 33.3729 27.9857 36.3131 25.0739C37.3957 24.0021 38.7104 24.0093 39.7965 25.0882C42.7118 27.9821 45.6128 30.8866 48.5066 33.8055C49.582 34.888 49.6141 36.3349 48.6388 37.3031C47.6921 38.2463 46.2237 38.1499 45.1412 37.0709C43.8157 35.7455 42.4903 34.4164 41.1648 33.0945C40.9505 32.8802 40.7182 32.6873 40.4253 32.4193C40.4217 37.4532 40.4217 42.3227 40.4217 47.2208Z"
          fill="#3AC38C"
        />
      </svg>
    ),
    [SVG_ICONS.ACCOUNT]: (
      <svg
        viewBox="0 0 24 24"
        fill="none"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <g clipPath="url(#clip0)">
          <path
            d="M9 10C6.243 10 4 7.757 4 5C4 2.243 6.243 0 9 0C11.757 0 14 2.243 14 5C14 7.757 11.757 10 9 10ZM9 1C6.794 1 5 2.794 5 5C5 7.206 6.794 9 9 9C11.206 9 13 7.206 13 5C13 2.794 11.206 1 9 1Z"
            fill="#fff"
          />
          <path
            d="M8.5 21H0.5C0.224 21 0 20.776 0 20.5V16.5C0 14.019 2.019 12 4.5 12H10.5C10.776 12 11 12.224 11 12.5C11 12.776 10.776 13 10.5 13H4.5C2.57 13 1 14.57 1 16.5V20H8.5C8.776 20 9 20.224 9 20.5C9 20.776 8.776 21 8.5 21Z"
            fill="#fff"
          />
          <path
            d="M17 20C15.622 20 14.5 18.878 14.5 17.5C14.5 16.122 15.622 15 17 15C18.378 15 19.5 16.122 19.5 17.5C19.5 18.878 18.378 20 17 20ZM17 16C16.173 16 15.5 16.673 15.5 17.5C15.5 18.327 16.173 19 17 19C17.827 19 18.5 18.327 18.5 17.5C18.5 16.673 17.827 16 17 16Z"
            fill="#fff"
          />
          <path
            d="M17.797 24H16.202C15.686 24 15.258 23.613 15.207 23.099L15.08 21.828C14.777 21.693 14.488 21.525 14.215 21.325L13.047 21.852C12.578 22.066 12.027 21.887 11.77 21.44L10.973 20.059C10.715 19.612 10.837 19.048 11.255 18.747L12.284 18.007C12.264 17.852 12.25 17.68 12.25 17.5C12.25 17.32 12.264 17.147 12.284 16.993L11.255 16.253C10.837 15.952 10.715 15.388 10.973 14.941L11.77 13.56C12.028 13.113 12.576 12.936 13.047 13.148L14.215 13.675C14.488 13.475 14.777 13.307 15.08 13.172L15.207 11.901C15.258 11.388 15.686 11.001 16.202 11.001H17.797C18.313 11.001 18.741 11.388 18.792 11.902L18.919 13.173C19.223 13.308 19.512 13.477 19.784 13.676L20.952 13.149C21.423 12.938 21.972 13.115 22.229 13.561L23.026 14.942C23.284 15.389 23.162 15.953 22.744 16.254L21.715 16.994C21.735 17.149 21.749 17.321 21.749 17.501C21.749 17.681 21.735 17.854 21.715 18.008L22.744 18.748C23.162 19.049 23.284 19.613 23.026 20.06L22.23 21.44C21.972 21.886 21.425 22.065 20.953 21.852L19.785 21.325C19.512 21.525 19.223 21.693 18.92 21.828L18.792 23.1C18.741 23.613 18.313 24 17.797 24ZM14.285 20.245C14.4 20.245 14.514 20.285 14.606 20.362C14.945 20.646 15.32 20.863 15.719 21.009C15.899 21.075 16.026 21.238 16.045 21.429L16.203 23H17.798L17.955 21.429C17.974 21.238 18.101 21.075 18.281 21.009C18.68 20.863 19.055 20.645 19.394 20.362C19.542 20.239 19.746 20.211 19.92 20.29L21.364 20.942L22.161 19.561L20.883 18.643C20.727 18.531 20.65 18.339 20.682 18.15C20.719 17.939 20.749 17.724 20.749 17.502C20.749 17.28 20.719 17.065 20.682 16.854C20.649 16.665 20.727 16.474 20.883 16.361L22.161 15.443L21.364 14.062L19.92 14.713C19.745 14.792 19.541 14.764 19.393 14.641C19.055 14.357 18.681 14.14 18.28 13.994C18.1 13.928 17.973 13.765 17.954 13.574L17.797 12H16.202L16.045 13.571C16.026 13.762 15.899 13.925 15.719 13.991C15.32 14.137 14.945 14.355 14.606 14.638C14.459 14.761 14.255 14.79 14.08 14.71L12.636 14.058L11.839 15.439L13.117 16.357C13.273 16.469 13.35 16.661 13.318 16.85C13.281 17.061 13.251 17.276 13.251 17.498C13.251 17.72 13.281 17.935 13.318 18.146C13.351 18.335 13.273 18.526 13.117 18.639L11.839 19.557L12.636 20.938L14.08 20.287C14.146 20.259 14.215 20.245 14.285 20.245Z"
            fill="white"
          />
        </g>
        <defs>
          <clipPath id="clip0">
            <rect width="24" height="24" fill="white" />
          </clipPath>
        </defs>
      </svg>
    ),
    [SVG_ICONS.ARROW_CIRCLE_DOWN]: (
      <svg
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11 21C5.47715 21 1 16.5228 1 11C1 5.47715 5.47715 1 11 1C16.5228 1 21 5.47715 21 11C21 16.5228 16.5228 21 11 21Z"
          stroke="#7D7D7D"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.46997 9.73999L11 13.26L14.53 9.73999"
          stroke="#7D7D7D"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
    [SVG_ICONS.ARROW_CIRCLE_UP]: (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2Z"
          stroke={props.color || "#0095E9"}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.53 13.26L12 9.74001L8.47003 13.26"
          stroke={props.color || "#0095E9"}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
    [SVG_ICONS.ARTICLES]: (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M11.7992 11.8999C11.2992 11.8999 10.6992 11.7999 10.2992 11.5999L4.39922 8.9999C2.89922 8.2999 2.69922 7.3999 2.69922 6.8999C2.69922 6.3999 2.89922 5.4999 4.39922 4.7999L10.2992 2.1999C11.1992 1.7999 12.4992 1.7999 13.3992 2.1999L15.2992 2.9999C15.6992 3.1999 15.7992 3.5999 15.6992 3.9999C15.5992 4.3999 15.0992 4.5999 14.6992 4.3999L12.7992 3.4999C12.2992 3.2999 11.3992 3.2999 10.9992 3.4999L4.99922 6.1999C4.39922 6.4999 4.19922 6.7999 4.19922 6.8999C4.19922 6.9999 4.39922 7.2999 4.99922 7.5999L10.8992 10.1999C11.3992 10.3999 12.2992 10.3999 12.6992 10.1999L18.5992 7.5999C19.1992 7.2999 19.3992 6.9999 19.3992 6.8999C19.3992 6.7999 19.1992 6.4999 18.5992 6.1999C18.1992 5.9999 17.9992 5.5999 18.1992 5.1999C18.3992 4.7999 18.7992 4.6999 19.1992 4.7999C20.6992 5.4999 20.8992 6.3999 20.8992 6.8999C20.8992 7.3999 20.6992 8.2999 19.1992 8.9999L13.2992 11.5999C12.8992 11.7999 12.2992 11.8999 11.7992 11.8999Z"
          fill="#C4C4C4"
        />
        <path
          d="M12.0008 17.0998C11.6008 17.0998 11.2008 16.9998 10.9008 16.8998L4.10078 13.8998C3.10078 13.3998 2.30078 12.1998 2.30078 11.0998C2.30078 10.6998 2.60078 10.2998 3.10078 10.2998C3.60078 10.2998 3.90078 10.5998 3.90078 11.0998C3.90078 11.5998 4.40078 12.2998 4.90078 12.5998L11.7008 15.5998C12.0008 15.6998 12.4008 15.6998 12.7008 15.5998L19.5008 12.5998C20.0008 12.3998 20.5008 11.6998 20.5008 11.0998C20.5008 10.6998 20.8008 10.2998 21.3008 10.2998C21.8008 10.2998 22.1008 10.5998 22.1008 11.0998C22.1008 12.1998 21.3008 13.4998 20.3008 13.8998L13.5008 16.8998C12.8008 16.9998 12.4008 17.0998 12.0008 17.0998Z"
          fill="#C4C4C4"
        />
        <path
          d="M11.9992 22.1002C11.5992 22.1002 11.1992 22.0002 10.8992 21.9002L4.09922 18.9002C2.99922 18.3002 2.19922 17.2002 2.19922 16.0002C2.19922 15.6002 2.49922 15.2002 2.99922 15.2002C3.49922 15.2002 3.79922 15.5002 3.79922 16.0002C3.79922 16.6002 4.19922 17.2002 4.79922 17.5002L11.5992 20.5002C11.8992 20.6002 12.2992 20.6002 12.5992 20.5002L19.3992 17.5002C19.9992 17.2002 20.3992 16.7002 20.3992 16.0002C20.3992 15.6002 20.6992 15.2002 21.1992 15.2002C21.6992 15.2002 21.9992 15.5002 21.9992 16.0002C21.9992 17.2002 21.2992 18.3002 20.1992 18.8002L13.3992 21.8002C12.7992 22.0002 12.3992 22.1002 11.9992 22.1002Z"
          fill="#C4C4C4"
        />
      </svg>
    ),
    [SVG_ICONS.INVOICES]: (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M11.4992 22.8002C10.6992 22.8002 9.99922 22.4002 9.39922 21.7002L8.39922 20.4002C8.19922 20.1002 7.89922 20.0002 7.59922 19.9002C7.29922 19.9002 6.99922 20.0002 6.79922 20.3002C5.89922 21.2002 5.09922 21.7002 4.29922 21.6002C3.79922 21.6002 3.29922 21.3002 2.89922 20.9002C2.89922 20.8002 2.79922 20.8002 2.79922 20.7002C2.39922 19.9002 2.19922 18.7002 2.19922 17.0002V11.0002C2.19922 10.6002 2.49922 10.2002 2.99922 10.2002C3.49922 10.2002 3.79922 10.5002 3.79922 11.0002V17.0002C3.79922 18.4002 3.89922 19.4002 4.19922 20.0002C4.19922 20.0002 4.29922 20.0002 4.39922 20.0002C4.69922 20.0002 5.09922 19.8002 5.69922 19.1002C6.29922 18.5002 6.99922 18.2002 7.69922 18.2002C8.39922 18.2002 9.09922 18.6002 9.59922 19.3002L10.5992 20.6002C11.0992 21.3002 11.7992 21.3002 12.2992 20.6002L13.2992 19.3002C13.7992 18.7002 14.4992 18.3002 15.1992 18.2002C15.8992 18.2002 16.6992 18.5002 17.1992 19.1002C17.8992 19.9002 18.3992 20.0002 18.4992 20.0002C18.5992 20.0002 18.5992 20.0002 18.6992 19.9002C18.9992 19.3002 19.0992 18.3002 19.0992 16.9002V7.0002C19.0992 5.6002 18.9992 4.6002 18.6992 4.0002C18.7992 4.0002 18.6992 4.0002 18.5992 4.0002C18.4992 4.0002 17.9992 4.1002 17.2992 4.9002C16.7992 5.5002 15.9992 5.8002 15.2992 5.8002C14.5992 5.8002 13.8992 5.4002 13.3992 4.7002L12.3992 3.4002C11.8992 2.7002 11.1992 2.7002 10.6992 3.4002L9.69922 4.8002C9.19922 5.4002 8.49922 5.8002 7.79922 5.9002C7.09922 5.9002 6.29922 5.60019 5.79922 5.1002C5.09922 4.2002 4.59922 4.0002 4.39922 4.0002C4.29922 4.0002 4.19922 4.0002 4.09922 4.1002C3.89922 4.7002 3.79922 5.6002 3.79922 7.0002C3.79922 7.4002 3.49922 7.8002 2.99922 7.8002C2.49922 7.8002 2.19922 7.5002 2.19922 7.0002C2.19922 5.3002 2.39922 4.2002 2.79922 3.3002C2.79922 3.2002 2.89922 3.2002 2.89922 3.1002C3.19922 2.7002 3.69922 2.4002 4.29922 2.4002C5.09922 2.4002 5.89922 2.8002 6.79922 3.7002C6.99922 4.1002 7.29922 4.2002 7.59922 4.2002C7.89922 4.2002 8.19922 4.0002 8.39922 3.7002L9.39922 2.3002C9.89922 1.6002 10.6992 1.2002 11.4992 1.2002C12.2992 1.2002 12.9992 1.6002 13.5992 2.3002L14.5992 3.6002C14.7992 3.9002 15.0992 4.1002 15.3992 4.1002C15.6992 4.1002 15.9992 4.0002 16.1992 3.7002C16.9992 2.8002 17.7992 2.4002 18.5992 2.4002C19.1992 2.4002 19.6992 2.7002 19.9992 3.1002C19.9992 3.2002 20.0992 3.2002 20.0992 3.3002C20.4992 4.1002 20.6992 5.3002 20.6992 7.0002V17.0002C20.6992 18.7002 20.4992 19.8002 20.0992 20.7002C20.0992 20.8002 19.9992 20.9002 19.8992 21.0002C19.5992 21.4002 19.0992 21.6002 18.4992 21.6002C17.6992 21.6002 16.8992 21.2002 16.0992 20.3002C15.8992 20.0002 15.5992 19.9002 15.2992 19.9002C14.9992 19.9002 14.6992 20.1002 14.4992 20.4002L13.4992 21.7002C12.9992 22.3002 12.2992 22.8002 11.4992 22.8002Z"
          fill="#C4C4C4"
        />
        <path
          d="M15.9992 10.9999H14.9992C14.5992 10.9999 14.1992 10.6999 14.1992 10.1999C14.1992 9.6999 14.4992 9.3999 14.9992 9.3999H15.9992C16.3992 9.3999 16.7992 9.6999 16.7992 10.1999C16.7992 10.6999 16.3992 10.9999 15.9992 10.9999Z"
          fill="#C4C4C4"
        />
        <path
          d="M11.9992 11H7.99922C7.59922 11 7.19922 10.7 7.19922 10.2C7.19922 9.7 7.59922 9.5 7.99922 9.5H11.9992C12.3992 9.5 12.7992 9.8 12.7992 10.3C12.7992 10.8 12.3992 11 11.9992 11Z"
          fill="#C4C4C4"
        />
        <path
          d="M13.9992 14.5H7.99922C7.59922 14.5 7.19922 14.2 7.19922 13.7C7.19922 13.2 7.59922 13 7.99922 13H13.9992C14.3992 13 14.7992 13.3 14.7992 13.8C14.7992 14.3 14.3992 14.5 13.9992 14.5Z"
          fill="#C4C4C4"
        />
      </svg>
    ),
    [SVG_ICONS.OVERVIEW]: (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M14.9998 22.8002H8.9998C3.5998 22.8002 1.1998 20.5002 1.1998 15.0002V10.5C1.1998 10.1 1.4998 10.7 1.9998 10.7C2.4998 10.7 2.7998 10 2.7998 10.5V15.0002C2.7998 19.6002 4.3998 21.2002 8.9998 21.2002H14.9998C19.5998 21.2002 21.1998 19.6002 21.1998 15.0002V9.0002C21.1998 4.4002 19.5998 2.8002 14.9998 2.8002H8.9998C4.3998 2.8002 2.79922 6.1 2.79922 10.7C2.79922 11.1 2.49922 11.5 1.99922 11.5C1.49922 11.5 1.19922 11.1 1.19922 10.7C1.19922 5.3 3.4998 1.2002 8.9998 1.2002H14.9998C20.3998 1.2002 22.7998 3.5002 22.7998 9.0002V15.0002C22.7998 20.4002 20.3998 22.8002 14.9998 22.8002Z"
          fill="#C4C4C4"
        />
        <path
          d="M17.9992 18.1999H13.9992C13.5992 18.1999 13.1992 17.8999 13.1992 17.3999V7.1999C13.1992 6.7999 13.4992 6.3999 13.9992 6.3999H16.7992C17.8992 6.3999 18.7992 7.1999 18.7992 8.2999V17.3999C18.7992 17.7999 18.3992 18.1999 17.9992 18.1999ZM14.7992 16.6999H17.2992V8.2999C17.2992 8.0999 17.0992 7.8999 16.7992 7.8999H14.7992V16.6999Z"
          fill="#C4C4C4"
        />
        <path
          d="M13.9992 18.2H9.99922C9.59922 18.2 9.19922 17.9 9.19922 17.4V12.7C9.19922 11.7 9.99922 10.8 11.0992 10.8C11.4992 10.7 12.3992 10.6 13.1992 10.8V7.7C13.2992 7.3 13.5992 7 13.9992 7C14.3992 7 14.7992 7.3 14.7992 7.8V17.5C14.7992 17.8 14.3992 18.2 13.9992 18.2ZM10.7992 16.7H13.2992V12.6V12.5C12.9992 12.3 12.1992 12.2 11.3992 12.3H11.2992C11.0992 12.3 10.8992 12.5 10.8992 12.7V16.7H10.7992Z"
          fill="#C4C4C4"
        />
        <path
          d="M9.99922 18.2001H5.99922C5.59922 18.2001 5.19922 17.9001 5.19922 17.4001V14.0001C5.19922 13.0001 6.09922 12.1001 7.19922 12.1001H9.99922C10.3992 12.1001 10.7992 12.4001 10.7992 12.9001V17.4001C10.7992 17.8001 10.3992 18.2001 9.99922 18.2001ZM6.79922 16.7001H9.29922V13.7001H7.29922C7.09922 13.7001 6.79922 13.9001 6.79922 14.1001V16.7001Z"
          fill="#C4C4C4"
        />
      </svg>
    ),
  };

  if (!icons[props.name]) return <></>;
  const svg = React.cloneElement(icons[props.name], {
    style: props.style,
    className: props.className,
  });

  return svg;
};

export default SVG;
